import React from 'react'
import PropTypes from 'prop-types'
import RedirectRule from 'pages/RedirectRule'

export const CurriculumRedirectRule = props => {
  const normalizedMatch = {
    ...props.match,
    url: props.match?.url?.replace(/\/+$/, ''),
  }

  return <RedirectRule {...props} match={normalizedMatch} />
}

CurriculumRedirectRule.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string,
  }),
}

export default CurriculumRedirectRule
